import { ClipLoader } from "react-spinners";

const Spinner = ({ size = 40, inline = false, color = "#3498db" }) => {
  if (inline) {
    return <ClipLoader size={size} color={color} />;
  }
  return (
    <div style={{ textAlign: "center", marginTop: "2rem" }}>
      <ClipLoader size={size} color={color} />
    </div>
  );
}

export default Spinner;